/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_IntroInputs */

const en_to_yaml_intro = /** @type {(inputs: To_Yaml_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert JSON to YAML for Kubernetes manifests, CI pipelines, and Compose files. Strings that a YAML reader might misinterpret are quoted automatically.`)
};

const ko_to_yaml_intro = /** @type {(inputs: To_Yaml_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kubernetes 매니페스트, CI 파이프라인, Compose 파일을 위해 JSON을 YAML로 변환합니다. YAML 리더가 잘못 해석할 수 있는 문자열은 자동으로 인용됩니다.`)
};

const ja_to_yaml_intro = /** @type {(inputs: To_Yaml_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kubernetes マニフェスト、CI パイプライン、Compose ファイルのために JSON を YAML に変換します。YAML リーダが誤解しうる文字列は自動で引用されます。`)
};

/**
* | output |
* | --- |
* | "Convert JSON to YAML for Kubernetes manifests, CI pipelines, and Compose files. Strings that a YAML reader might misinterpret are quoted automatically." |
*
* @param {To_Yaml_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_intro = /** @type {((inputs?: To_Yaml_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_intro(inputs)
	if (locale === "ko") return ko_to_yaml_intro(inputs)
	return ja_to_yaml_intro(inputs)
});